import AuthenticationDataComponent from "./AuthenticationDataComponent";

export { AuthenticationDataComponent };
